import React from "react";
import LandingSection from "../components/LandingSection";
import "../styles/SiteMap.css"; // Make sure your hexagon CSS is here
import Header from "../components/Header";
import { useState } from "react";
import "../App.css";
import Footer from "../components/Footer";

const verticals = [
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
  {
    title: "Real Estate and Rental and Leasing",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Manufacturing",
    path: "/verticals/manufacturing ",
    bgColor: "#1542c4",
  },
  {
    title: "Aerospace and Defense",
    path: "/verticals/aerospace-and-defense ",
    bgColor: "#C70039",
  },
  {
    title: "Food Industry",
    path: "/verticals/food-industry ",
    bgColor: "#1542c4",
  },
  {
    title: "Government (Public Administration)",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: "Professional, Scientific, and Technical Services",
    path: "/verticals/professional-scientific-and-technical-services",
    bgColor: "#C70039",
  },
  {
    title: "Healthcare and Social Assistance",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: "Finance and Insurance",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Retail Trade",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: "Wholesale Trade",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Information",
    path: "/verticals/information",
    bgColor: "#1542c4",
  },
  {
    title: "Construction",
    path: "/verticals/construction",
    bgColor: "#C70039",
  },
  {
    title: "Transportation and Warehousing",
    path: "/verticals/transportation-and-warehousing",
    bgColor: "#1542c4",
  },
  {
    title: "Utilities",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Mining",
    path: "/verticals/mining",
    bgColor: "#1542c4",
  },
  {
    title: "Arts, Entertainment, and Recreation",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
];

const UtahAtAGlance = [
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
  {
    title: "Governor's Corner",
    path: "/utah-at-a-glance/utah-governor",
    bgColor: "#C70039",
  },
  {
    title: "What's New",
    path: "/utah-at-a-glance/whats-new",
    bgColor: "#1542c4",
  },
  {
    title: "Adventure Activities",
    path: "/utah-at-a-glance/adventure-activities",
    bgColor: "#1542c4",
  },
  {
    title: "Air Quality Index",
    path: "/utah-at-a-glance/air-quality-index",
    bgColor: "#1542c4",
  },
  {
    title: "Airports",
    path: "/utah-at-a-glance/utah-airports",
    bgColor: "#1542c4",
  },
  {
    title: "Autism and DD",
    path: "/utah-at-a-glance/autism-dd",
    bgColor: "#1542c4",
  },
  {
    title: "Budget",
    path: "/utah-at-a-glance/utah-budget",
    bgColor: "#C70039",
  },
  {
    title: "Construction Intelligence",
    path: "/utah-at-a-glance/construction-intelligence",
    bgColor: "#1542c4",
  },
  {
    title: "Charging Stations",
    path: "/utah-at-a-glance/charging-stations",
    bgColor: "#C70039",
  },
  {
    title: "Cities",
    path: "/utah-at-a-glance/utah-cities",
    bgColor: "#C70039",
  },
  {
    title: "Counties",
    path: "/utah-at-a-glance/utah-counties",
    bgColor: "#C70039",
  },
  {
    title: "Demographics",
    path: "/utah-at-a-glance/demographics",
    bgColor: "#1542c4",
  },
  {
    title: "Employment",
    path: "/utah-at-a-glance/utah-employment",
    bgColor: "#C70039",
  },
  {
    title: "In-Demand Jobs & Wages",
    path: "/utah-at-a-glance/in-demand-jobs-and-wages",
    bgColor: "#1542c4",
  },
  {
    title: "Federal Agencies",
    path: "/utah-at-a-glance/federal-agencies",
    bgColor: "#1542c4",
  },
  {
    title: "Financial Institutions",
    path: "/utah-at-a-glance/financial-institutions",
    bgColor: "#1542c4",
  },
  {
    title: "Geothermal Hotspots",
    path: "/utah-at-a-glance/utah-geothermal-hotspots",
    bgColor: "#1542c4",
  },
  {
    title: "Hill Airforce Base",
    path: "/utah-at-a-glance/hill-airforce-base",
    bgColor: "#C70039",
  },
  {
    title: "Hospitals",
    path: "/utah-at-a-glance/hospitals",
    bgColor: "#1542c4",
  },
  {
    title: "Housing",
    path: "/utah-at-a-glance/utah-housing",
    bgColor: "#1542c4",
  },
  {
    title: "KCG Sandbox",
    path: "/kcg-sandbox",
    bgColor: "#C70039",
  },
  {
    title: "Libraries",
    path: "/utah-at-a-glance/utah-libraries",
    bgColor: "#C70039",
  },
  {
    title: "MLM",
    path: "/utah-at-a-glance/mlm",
    bgColor: "#C70039",
  },
  {
    title: "Mines",
    path: "/utah-at-a-glance/utah-mines",
    bgColor: "#C70039",
  },
  {
    title: "Utah Nonprofits",
    path: "/utah-at-a-glance/utah-nonprofits",
    bgColor: "#C70039",
  },
  {
    title: "Nonprofit Data Insights",
    path: "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
    bgColor: "#1542c4",
  },
  {
    title: "Operation Gigawatt",
    path: "/utah-at-a-glance/utah-operation-gigawatt",
    bgColor: "#1542c4",
  },
  {
    title: "Places to Visit",
    path: "/utah-at-a-glance/utah-places-to-visit",
    bgColor: "#C70039",
  },
  {
    title: "Research Centers and Institutes",
    path: "/utah-at-a-glance/research-centers-and-institutes",
    bgColor: "#1542c4",
  },
  {
    title: "Sports Club",
    path: "/utah-at-a-glance/sports-club",
    bgColor: "#C70039",
  },
  {
    title: "Taxes",
    path: "/utah-at-a-glance/taxes",
    bgColor: "#C70039",
  },
  {
    title: "Education and Intellectual Resources",
    path: "/utah-at-a-glance/universities-and-schools",
    bgColor: "#1542c4",
  },
  {
    title: "Utah Schools",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools",
    bgColor: "#1542c4",
  },
  {
    title: "Utah History",
    path: "/utah-at-a-glance/utah-history",
    bgColor: "#1542c4",
  },
  {
    title: "Utah Land Ownership",
    path: "/utah-at-a-glance/utah-land",
    bgColor: "#1542c4",
  },
  {
    title: "Utah Legislature",
    path: "/utah-at-a-glance/utah-legislature",
    bgColor: "#C70039",
  },
  {
    title: "Unemployment Rate",
    path: "/utah-at-a-glance/unemployment-rate",
    bgColor: "#C70039",
  },
  {
    title: "Voters Count",
    path: "/utah-at-a-glance/utah-voters-count",
    bgColor: "#C70039",
  },
  {
    title: "Zip Codes",
    path: "/utah-at-a-glance/zipcodes",
    bgColor: "#1542c4",
  },
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
];

// const generateHexRows = () => {
//   const width = window.innerWidth;
//   const rows = [];

//   if (width <= 600) {
//     // Mobile: alternate 3 and 2 items per row
//     for (let i = 0, toggle = true; i < UtahAtAGlance.length;) {
//       const count = toggle ? 3 : 2;
//       rows.push(UtahAtAGlance.slice(i, i + count));
//       i += count;
//       toggle = !toggle;
//     }
//   } else if (width > 600 && width < 1030) {
//     // Tablet: 5 items per row
//     for (let i = 0; i < UtahAtAGlance.length; i += 5) {
//       rows.push(UtahAtAGlance.slice(i, i + 5));
//     }
//   } else {
//     // Desktop: 7 items per row
//     for (let i = 0; i < UtahAtAGlance.length; i += 9) {
//       rows.push(UtahAtAGlance.slice(i, i + 9));
//     }
//   }

//   return rows;
// };

// const hexRows = generateHexRows();

const otherPages = [
  { title: " ", path: " ", bgColor: " " },

  { title: " ", path: " ", bgColor: " " },
  { title: "Login", path: "/login", bgColor: "#C70039" },
  { title: "About Us", path: "/about-us", bgColor: "#1542c4" },
  { title: "Privacy Policy", path: "/privacy-policy", bgColor: "#C70039" },
  { title: "Contact Us", path: "/contact-us", bgColor: "#1542c4" },

  { title: "Gallery", path: "/gallery", bgColor: "#C70039" },
  { title: "KCG", path: "/kcg", bgColor: "#1542c4" },
  { title: "Ask Betsy AI", path: "/betsy", bgColor: "#C70039" },
  { title: "NAICS", path: "/get-naics", bgColor: "#1542c4" },

  { title: "Copyright", path: "/copyright", bgColor: "#C70039" },
  { title: "FAQs", path: "/faq", bgColor: "#1542c4 " },
  { title: "Founder's Note", path: "/founders-note", bgColor: "#C70039 " },
  {
    title: "Support Sponsor Request",
    path: "/support-sponsor-request",
    bgColor: "#1542c4",
  },
  {
    title: "Supporters And Sponsors",
    path: "/supporters-and-sponsors",
    bgColor: "#C70039 ",
  },
  { title: "WIP", path: "/wip", bgColor: "#1542c4" },
  { title: " ", path: " ", bgColor: " " },
  { title: " ", path: " ", bgColor: " " },
];

const HexGridSection = ({
  title,
  data,
  activeTab,
  setActiveTab,
  setSelectedTitle,
  url,
}) => {
  const generateHexRows = () => {
    const width = window.innerWidth;
    const rows = [];

    if (width <= 600) {
      for (let i = 0, toggle = true; i < data.length; ) {
        const count = toggle ? 3 : 2;
        rows.push(data.slice(i, i + count));
        i += count;
        toggle = !toggle;
      }
    } else if (width > 600 && width < 1030) {
      for (let i = 0; i < data.length; i += 5) {
        rows.push(data.slice(i, i + 5));
      }
    } else {
      for (let i = 0; i < data.length; i += 9) {
        rows.push(data.slice(i, i + 9));
      }
    }

    return rows;
  };

  const hexRows = generateHexRows();

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center">
        <a href={url} className="no-underline">
          {" "}
          {title}
        </a>
      </h1>
      <div className="hex-grid">
        {hexRows.map((row, index) => {
          const shouldOffsetRow =
            index % 2 !== 0 ||
            (title === "Utah At a Glance" &&
              index === hexRows.length - 1 &&
              row.length < 9);

          return (
          <div
            key={index}
            className={`hex-row ${shouldOffsetRow ? "offset" : ""}`}
          >
            {row.map(({ title, path, bgColor }, i) => (
              <div key={i} className="hex-border">
                <div className="hex-wrapper">
                  {title && title.trim() !== "" ? (
                    <a
                      href={path || "#"}
                      className="hex-inner no-underline"
                      style={{ backgroundColor: bgColor || "#3a3aab" }}
                    >
                      <div className="upperHexa">
                        <div
                          className={`hexagon ${activeTab === title ? "active" : ""}`}
                          onClick={() => {
                            setActiveTab(title);
                            setSelectedTitle(title);
                          }}
                          style={{ color: bgColor }}
                        >
                          <span className="hex-title">{title}</span>
                        </div>
                      </div>
                    </a>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
          );
        })}
      </div>
    </div>
  );
};

function SiteMap2() {
  const [selectedTitle, setSelectedTitle] = useState(null);
  // const filteredCards = selectedTitle ? leftPanel.filter((item) =>(item.title===selectedTitle)):leftPanel
  const [activeTab, setActiveTab] = useState("");
  return (
    <div>
      {/* <LandingSection data={{ imageName: 'recreation.webp', title: 'Utah Site Map' }} /> */}

      <Header />
      <div className="mt-[8rem]">
        <h1 className="flex justify-center">UTahData.org Visual Site Map</h1>
        {/* <HexGridSection title="Utah Verticals" data={verticals} />
      <HexGridSection title="Utah At a Glance" data={UtahAtAGlance} />
      <HexGridSection title="Other Pages" data={otherPages} /> */}
        <HexGridSection
          title="Utah Verticals"
          data={verticals}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedTitle={setSelectedTitle}
          url="/verticals"
        />
        <HexGridSection
          title="Utah At a Glance"
          data={UtahAtAGlance}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedTitle={setSelectedTitle}
          url="/utah-at-a-glance"
        />
        <HexGridSection
          title="Other Pages"
          data={otherPages}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedTitle={setSelectedTitle}
          url=""
        />
      </div>
      <Footer />
    </div>
  );
}

export default SiteMap2;
